import { render } from "./contracts-chart.vue?vue&type=template&id=006d9432&lang=true"
import script from "./contracts-chart.vue?vue&type=script&lang=js"
export * from "./contracts-chart.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__